import RouterView from '@/components/layout/Router.vue';
import { addTeamScheduleRoute } from './schedule/add.route';
import { editTeamScheduleRoute } from './schedule/edit.route';
import { teamSchedulesRoute } from './schedule/schedules.route';

export const teamSchedulesContainerRoute = {
  path: 'schedules',
  component: RouterView,
  meta: { title: 'titles.team.schedules' },
  children: [addTeamScheduleRoute, editTeamScheduleRoute, teamSchedulesRoute]
};
